module.exports = __webpack_public_path__ + "static/media/Chimie.1fac851d.gif";